<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class style="position: relative;margin-top: 30px;" :getContainer="handleScollMain">
        <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
          <a-form-item label="培训项目" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-input
              placeholder="请输入项目名称"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入项目名称!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="培训类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-radio-group 
               v-decorator="[
                  'trainType',
                  {rules: [],initialValue:info.trainType}
                ]">
                <a-radio :value="1">网授</a-radio>
                <a-radio :value="2">面授</a-radio>
              </a-radio-group>
          </a-form-item>
          <a-form-item label="培训价格" style="margin-bottom:0;" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-form-item   :style="{ display: 'inline-block', width: '160px' }">
                <a-input
                :disabled="free"
                placeholder="请输入培训价格"
                v-decorator="[
                'fee',
                {rules: [{ required: true, message: '请输入培训价格!' }],initialValue:info.fee}
              ]"
              ></a-input>
            </a-form-item>
            <a-form-item   :style="{ display: 'inline-block',marginLeft: '15px' }">
                <a-switch default-checked v-model="free" @change="freeChanged"/> 免费
            </a-form-item>
          </a-form-item>
          
          <a-form-item label="封面图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :beforeUpload="beforeUpload"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length ==0">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
          <a-form-item label="培训简介" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-textarea :rows="4" 
               v-decorator="[
            'description',
            {rules: [],initialValue:info.description}
          ]"/>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
    
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    id: String,
  },
  watch:{
    id: {
      immediate:true, 
      handler(newVal,oldVal) {
        if(this.id && this.id!='0'){
          this.getInfo();
        }
      }
    } 
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        status: true,
        trainType:1
      },
      free:false,
      previewVisible: false,
      previewImage: "",
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      uploadImg: []
    };
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      if(this.id && this.id!='0'){
        this.getInfo();
      }
    });
  },
  methods: {
    freeChanged(v){
      this.form.resetFields(["fee"])
      if(v){
        this.info.fee=0;
      }else{
        this.info.fee=null;
      }
      this.free=v;
    },
    getInfo(){
      this.$api.project
        .getById(
          this.id
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info=res.data;
            this.free=this.info.fee==0;
            if (res.data.picture) {
              var picurlArr = res.data.picture.split(",");
              picurlArr.forEach(function(item, index) {
                that.fileList.push({
                  name: item,
                  response: { data: { name: item, path: item } },
                  uid: item,
                  thumbUrl: item
                });
              });
            }
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
   
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isloading = true;
          if(this.id>0){
            values.id=this.id;
          }
          if(this.fileList){
            this.uploadImg = [];
            this.fileList.forEach(function(item, index) {
              that.uploadImg.push(item.response.data.path);
            });
            values.picture=this.uploadImg.join(",") ;
          }
          
          this.$api.project
            .saveOrUpdate(
              values
            )
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.$emit("callbackMethod",res.data);
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    handleScollMain() {
      return document.querySelector(".ant-modal-wrap");
    }
  }
};
</script>
<style>
</style>